import { Fragment } from "react";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
} from "@bigbinary/neeto-atoms/primitives";
import { Home } from "lucide-react";
import { isPresent } from "neetocist";
import { handleMetaClick } from "neetocommons/react-utils";
import { hyphenize } from "neetocommons/utils/general";
import { omit } from "ramda";
import { useHistory } from "react-router-dom";

import CheckPointNavLinks from "./CheckPointNavLink";
import SubLinkItem from "./SubLinkItem";

import { DEFAULT_HOME_PATH } from "../constants";
import { filterByPermissions } from "../utils";

const ConfigureView = ({
  navLink = { label: "", items: [], isConfigureNavLink: false },
  handleGoBack,
  isConfigureSidebar: _isConfigureSidebar,
}) => {
  const history = useHistory();
  const { label, items, ...otherProps } = navLink;

  const handleHomeButtonClick = e => {
    e.stopPropagation();
    handleMetaClick(history, DEFAULT_HOME_PATH, e);
  };

  const renderItems = itemList => (
    <SidebarMenu className="gap-1">
      {itemList.filter(filterByPermissions).map((subItem, subIndex) => (
        <Fragment key={subIndex}>
          {isPresent(subItem.items) ? (
            <SidebarMenuItem>
              <SidebarMenuButton asChild className="font-medium">
                <CheckPointNavLinks
                  href={subItem.href}
                  to={subItem.to ?? subItem.path}
                  onClick={subItem.onClick}
                >
                  {subItem.label}
                </CheckPointNavLinks>
              </SidebarMenuButton>
              <SidebarMenuSub>
                {subItem.items
                  .filter(filterByPermissions)
                  .map((nestedItem, nestedIndex) => (
                    <SubLinkItem
                      key={nestedIndex}
                      {...{ ...nestedItem }}
                      href={nestedItem.href}
                      isActive={nestedItem.isActive}
                      to={nestedItem.to ?? nestedItem.path}
                      onClick={nestedItem.onClick}
                    />
                  ))}
              </SidebarMenuSub>
            </SidebarMenuItem>
          ) : (
            <SubLinkItem
              {...{ ...subItem }}
              href={subItem.href}
              isActive={subItem.isActive}
              to={subItem.to ?? subItem.path}
              onClick={subItem.onClick}
            />
          )}
        </Fragment>
      ))}
    </SidebarMenu>
  );

  return (
    <SidebarGroup data-testid="configure-nav-container">
      <SidebarGroupLabel
        className="border-sidebar-border text-sidebar-foreground mb-2 h-10 cursor-pointer gap-1.5 rounded-none border-b px-3 text-sm font-semibold"
        onClick={handleGoBack}
        {...{ ...omit(["icon", "isConfigureNavLink"], otherProps) }}
      >
        <Home
          className="size-4 shrink-0 cursor-pointer"
          data-testid={`${hyphenize(label)}-go-back-button`}
          onClick={handleHomeButtonClick}
        />
        <span className="text-sidebar-foreground/50">/</span>
        <span>{label}</span>
      </SidebarGroupLabel>
      <SidebarGroupContent>{items && renderItems(items)}</SidebarGroupContent>
    </SidebarGroup>
  );
};

export default ConfigureView;
